// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ipBlock[data-v-3814b2b2] {\n  text-align: left;\n  color: darkgray;\n  font-size: 0.7em;\n}", ""]);
// Exports
module.exports = exports;
